import React from 'react';
import { ButtonVariant } from '../Components/Button';
import { StyledDialogButton } from '../Components/Dialog/StyledDialogButton';
import { StyledPrompt } from '../Components/Prompts/StyledPrompt';
export var NavigationPrompt = function (_a) {
    var open = _a.open, onCancel = _a.onCancel, onDiscard = _a.onDiscard;
    return (React.createElement(StyledPrompt, { open: open, title: 'Save changes?', onCancel: onCancel, actions: [
            React.createElement(StyledDialogButton, { title: 'Cancel', key: 'cancel', variant: ButtonVariant.light, onClick: onCancel, testId: 'cancel' }, "Cancel"),
            React.createElement(StyledDialogButton, { title: 'Discard', key: 'discard', onClick: onDiscard, testId: 'discard' }, "Discard")
        ] }, "Unsaved changes will be lost."));
};
